import { NotificationEnum } from '../../../models/notificationEnum';
import { RecipientEnum } from '../../../models/recipientEnum';
import { TemplateTranslation } from '../../../models/translation';

export const templatesDe: TemplateTranslation = {
  locale: 'de',
  templates: {
    [NotificationEnum.ACCEPTED_TIME_TRACKING]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit wurde freigegeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde deine erfasste Arbeitszeit freigegeben:',
          },
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit wurde freigegeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit freigegeben:',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit wurde freigegeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit freigegeben:',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit wurde freigegeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit freigegeben:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit wurde freigegeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit freigegeben:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit wurde freigegeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit freigegeben:',
          },
        },
      },
      [RecipientEnum.ORGANISATION]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit wurde freigegeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit freigegeben:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit wurde freigegeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit freigegeben:',
          },
        },
      },
    },
    [NotificationEnum.ACTION_REQUIRED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Dienst hat keine Mitarbeitenden',
          body: {
            introText:
              'Bei folgendem Dienst wurden noch keine Mitarbeitenden eingeladen oder alle eingeladenen Mitarbeitenden haben abgesagt:',
            textBeforeAction: 'Lade wenn möglich weitere Mitarbeitenden ein:',
            actionButtonText: 'Zum Dienst',
          },
        },
        PUSH: {
          title: 'IN-POOL - Dienst hat keine Mitarbeitenden',
          body: 'Bei folgendem Dienst haben alle eingeladenen Mitarbeitenden haben abgesagt: {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Dienst hat keine Mitarbeitenden',
          body: {
            introText:
              'Bei folgendem Dienst wurden noch keine Mitarbeitende eingeladen oder alle eingeladenen Mitarbeitenden haben abgesagt:',
            textBeforeAction: 'Lade wenn möglich weitere Mitarbeitende ein:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Dienst hat keine Mitarbeitenden',
          body: {
            introText:
              'Bei folgendem Dienst wurden noch keine Mitarbeitende eingeladen oder alle eingeladenen Mitarbeitenden haben abgesagt:',
            textBeforeAction: 'Lade wenn möglich weitere Mitarbeitende ein:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.ACTION_REQUIRED_ACCEPT_INVITEE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Dienst hat eine neue Zusage',
          body: {
            introText: 'Folgender Dienst hat eine neue Zusage:',
            textBeforeAction: 'Akzeptiere den gewünschten Mitarbeitenden:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Dienst hat eine neue Zusage',
          body: {
            introText: 'Folgender Dienst hat eine neue Zusage:',
            textBeforeAction: 'Akzeptiere den gewünschten Mitarbeitenden:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Dienst hat eine neue Zusage',
          body: {
            introText: 'Folgender Dienst hat eine neue Zusage:',
            textBeforeAction: 'Akzeptiere den gewünschten Mitarbeitenden:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_ACTION_REQUIRED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Einsatz hat keine Mitarbeitenden',
          body: {
            introText:
              'Bei folgendem Einsatz wurden noch keine Mitarbeitenden eingeladen oder alle eingeladenen Mitarbeitenden haben abgesagt:',
            textBeforeAction: 'Lade wenn möglich weitere Mitarbeitenden ein:',
            actionButtonText: 'Zum Einsatz',
          },
        },
        PUSH: {
          title: 'IN-POOL - Einsatz hat keine Mitarbeitenden',
          body: 'Bei folgendem Einsatz haben alle eingeladenen Mitarbeitenden haben abgesagt: {{employment.department.displayName}} für {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Einsatz hat keine Mitarbeitenden',
          body: {
            introText:
              'Bei folgendem Einsatz wurden noch keine Mitarbeitende eingeladen oder alle eingeladenen Mitarbeitenden haben abgesagt:',
            textBeforeAction: 'Lade wenn möglich weitere Mitarbeitende ein:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_ACTION_REQUIRED_ACCEPT_INVITEE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Einsatz hat eine neue Zusage',
          body: {
            introText: 'Folgender Einsatz hat eine neue Zusage:',
            textBeforeAction: 'Akzeptiere den gewünschten Mitarbeitenden:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Einsatz hat eine neue Zusage',
          body: {
            introText: 'Folgender Einsatz hat eine neue Zusage:',
            textBeforeAction: 'Akzeptiere den gewünschten Mitarbeitenden:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Einsatz hat eine neue Zusage',
          body: {
            introText: 'Folgender Einsatz hat eine neue Zusage:',
            textBeforeAction: 'Akzeptiere den gewünschten Mitarbeitenden:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
    },
    [NotificationEnum.ADD_TIME_TRACKING]: {
      [RecipientEnum.USER]: {
        SMS: 'Zeiterfassung fehlt: für {{departmentName}} \nZum Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit erfassen',
          body: {
            introText:
              'Bei folgendem Dienst wurden noch keine Arbeitszeiten erfasst:',
            textBeforeAction: 'Erledige dies bitte möglichst zeitnah:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
        PUSH: {
          title: 'IN-POOL - Arbeitszeit erfassen',
          body: 'Zeiterfassung fehlt: {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.EXTERNAL_USER]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit erfassen',
          body: {
            introText: 'Erfasse bitte deine Arbeitszeit für folgenden Dienst:',
            textBeforeAction: 'Verwende dazu folgenden Link:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_FOR_CREATOR]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit freigeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit zur Freigabe übermittelt, bitte leiten Sie diese an die entsprechende Personen weiter:',
            textBeforeAction:
              'Bitte prüfe und gib die erfasste Arbeitszeit frei:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit freigeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit zur Freigabe übermittelt, bitte leiten Sie diese an die entsprechende Personen weiter:',
            textBeforeAction:
              'Bitte prüfe und gib die erfasste Arbeitszeit frei:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_FOR_HOSPITAL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit freigeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit zur Freigabe übermittelt:',
            textBeforeAction:
              'Bitte prüfe und gib die erfasste Arbeitszeit frei:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit freigeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit zur Freigabe übermittelt:',
            textBeforeAction:
              'Bitte prüfe und gib die erfasste Arbeitszeit frei:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_FOR_AGENCY]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit freigeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die erfasste Arbeitszeit zur Freigabe übermittelt:',
            textBeforeAction:
              'Bitte prüfe und gib die erfasste Arbeitszeit frei:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_REMINDER_FOR_CREATOR]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit freigeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die eingegebene Arbeitszeit noch nicht freigegeben, bitte leiten Sie diese an die entsprechende Personen weiter:',
            textBeforeAction: 'Bitte erledige dies möglichst zeitnah:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit freigeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die eingegebene Arbeitszeit noch nicht freigegeben, bitte leiten Sie diese an die entsprechende Personen weiter:',
            textBeforeAction: 'Bitte erledige dies möglichst zeitnah:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_REMINDER_FOR_HOSPITAL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit freigeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die eingegebene Arbeitszeit noch nicht freigegeben:',
            textBeforeAction: 'Bitte erledige dies möglichst zeitnah:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit freigeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die eingegebene Arbeitszeit noch nicht freigegeben:',
            textBeforeAction: 'Bitte erledige dies möglichst zeitnah:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_REMINDER_FOR_AGENCY]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Arbeitszeit freigeben',
          body: {
            introText:
              'Bei folgendem Dienst wurde die eingegebene Arbeitszeit noch nicht freigegeben:',
            textBeforeAction: 'Bitte erledige dies möglichst zeitnah:',
            actionButtonText: 'Zur Zeiterfassung',
          },
        },
      },
    },
    [NotificationEnum.BOOKED_INTERNAL]: {
      [RecipientEnum.USER]: {
        SMS: 'Du wurdest von {{customerName}} gebucht: {{departmentName}} \nZum Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Gebucht: {{{job.department.displayName}}}',
          body: {
            introText:
              'Du wurdest von {{customerName}} für folgenden Dienst gebucht:',
            outroText: 'Im Anhang findest du den Kalender Eintrag',
            actionButtonText: 'Zum Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Gebucht: {{job.department.displayName}}',
          body: 'Du wurdest von {{customerName}} gebucht: {{job.department.displayName}} am {{job.date}}{{#invitee.partialTimes}} / {{from}} - {{to}} {{/invitee.partialTimes}}{{^invitee.partialTimes}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}{{/invitee.partialTimes}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}} auf {{job.department.displayName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}} auf {{job.department.displayName}}',
          body: 'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht: {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}} auf {{job.department.displayName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}} auf {{job.department.displayName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}} auf {{job.department.displayName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}} auf {{job.department.displayName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}} auf {{job.department.displayName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.ORGANISATION]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_BOOKED_INTERNAL]: {
      [RecipientEnum.USER]: {
        SMS: 'Du wurdest von {{customerName}} gebucht: {{departmentName}} \nZum Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Gebucht: {{{employment.department.displayName}}}',
          body: {
            introText:
              'Du wurdest von {{customerName}} für folgenden Temporäreinsatz gebucht:',
            outroText: 'Im Anhang findest du den Kalender Eintrag',
            actionButtonText: 'Zum Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Gebucht: {{employment.department.displayName}}',
          body: 'Du wurdest von {{customerName}} gebucht: {{employment.department.displayName}} für {{formattedDate}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Einsatz gebucht:',
            actionButtonText: 'Zum Einsatz',
          },
        },
        PUSH: {
          title: 'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}}',
          body: 'Eine Person von {{customerName}} wurde für folgenden Einsatz gebucht: {{employment.department.displayName}} für {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Einsatz gebucht:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Einsatz gebucht:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Einsatz gebucht:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject: 'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Einsatz gebucht:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Einsatz gebucht:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
    },
    [NotificationEnum.BOOKED_EXTERNAL]: {
      [RecipientEnum.EXTERNAL_USER]: {
        EMAIL: {
          subject: 'IN-POOL - Gebucht: {{{job.department.displayName}}}',
          body: {
            introText:
              'Du wurdest von {{customerName}} für folgenden Dienst gebucht:',
            outroText:
              'Für die Zeiterfassung erhältst du automatisch kurz vor Dienstbeginn eine E-Mail mit einem Link, mit dem du die Stunden digital erfassen kannst.',
          },
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}} auf {{job.department.displayName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}} auf {{job.department.displayName}}',
          body: 'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht: {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}} auf {{job.department.displayName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Dienst gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_BOOKED_EXTERNAL]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Einsatz gebucht:',
            actionButtonText: 'Zum Einsatz',
          },
        },
        PUSH: {
          title: 'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}}',
          body: 'Eine Person von {{customerName}} wurde für folgenden Einsatz gebucht: {{employment.department.displayName}} für {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Einsatz gebucht:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Eine Person von {{customerName}} wurde für folgenden Einsatz gebucht:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
    },
    [NotificationEnum.DECLINED]: {
      [RecipientEnum.USER]: {
        SMS:
          'Ein Dienst konnte bereits anderweitig besetzt werden:\n' +
          '{{departmentName}}',
        EMAIL: {
          subject: 'IN-POOL - Absage für {{{job.department.displayName}}}',
          body: {
            introText:
              'Folgender Dienst konnte bereits anderweitig besetzt werden:',
          },
        },
        PUSH: {
          title: 'IN-POOL - Absage für {{job.department.displayName}}',
          body: 'Folgender Dienst konnte bereits anderweitig besetzt werden: {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Absage {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'Eine Person wurde für folgenden Dienst abgesagt:',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Absage {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'Eine Person wurde für folgenden Dienst abgesagt:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Absage {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'Eine Person wurde für folgenden Dienst abgesagt:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Absage {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'Eine Person wurde für folgenden Dienst abgesagt:',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INVITEE_DECLINED]: {
      [RecipientEnum.USER]: {
        SMS:
          'Ein Temporäreinsatz konnte bereits anderweitig besetzt werden:\n' +
          '{{departmentName}}',
        EMAIL: {
          subject:
            'IN-POOL - Absage für {{{employment.department.displayName}}}',
          body: {
            introText:
              'Folgender Temporäreinsatz konnte bereits anderweitig besetzt werden: ',
          },
        },
        PUSH: {
          title: 'IN-POOL - Absage für {{employment.department.displayName}}',
          body: 'Folgender Temporäreinsatz konnte bereits anderweitig besetzt werden: {{employment.department.displayName}} für {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Absage {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'Eine Person wurde für folgenden Einsatz abgesagt:',
          },
        },
      },
    },
    [NotificationEnum.ENROLL_POOLER_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Willkommen im {{{customerName}}}-Pool',
          body: {
            introText: 'Wir freuen uns, dich bei inpool zu begrüssen.',
            actionButtonPreText:
              'Bitte aktiviere dein Konto indem du mit folgendem Link dein Passwort setzt: ',
            actionButtonText: 'Konto aktivieren',
            actionButtonPostText: 'Dieser Link ist nur einmalig gültig.',
            secondaryActionPreText:
              'Du kannst dich zukünftig mit deiner E-Mail-Adresse und dem gewählten Passwort anmelden. Nutze dazu bitte diesen Link',
            secondaryActionText: 'Login',
          },
        },
      },
    },
    [NotificationEnum.ENROLL_DISPO_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Willkommen',
          body: {
            introText: 'Wir freuen uns, dich bei inpool zu begrüssen.',
            actionButtonPreText:
              'Bitte aktiviere dein Konto indem du mit folgendem Link dein Passwort setzt: ',
            actionButtonText: 'Konto aktivieren',
            actionButtonPostText: 'Dieser Link ist nur einmalig gültig.',
            secondaryActionPreText:
              'Du kannst dich zukünftig mit deiner E-Mail-Adresse und dem gewählten Passwort anmelden. Nutze dazu bitte diesen Link',
            secondaryActionText: 'Login',
          },
        },
      },
    },
    [NotificationEnum.ENROLL_DEMO_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'Inpool Demo - Passwort festlegen',
          body: {
            introText:
              'Willkommen in der inpool Demo! Deine Demo-Umgebung ist bereit.',
            actionButtonPreText:
              'Um mit der Demo zu starten, setze bitte dein Passwort mit folgendem Link: ',
            actionButtonText: 'Passwort festlegen',
            actionButtonPostText:
              'Dieser Link ist nur einmalig gültig. Nach dem Festlegen deines Passworts kannst du die Demo vollständig erkunden.',
            secondaryActionPreText:
              'Nach dem Festlegen deines Passworts kannst du dich jederzeit mit deiner E-Mail-Adresse anmelden. Nutze dazu diesen Link',
            secondaryActionText: 'Zur Demo',
          },
        },
      },
    },
    [NotificationEnum.DEMO_WELCOME]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'Willkommen zur Demo',
          body: {
            introText: 'Willkommen zur Demo!',
            actionButtonPreText:
              'Über folgenden Link kannst du dich zukünftig anmelden:',
            actionButtonText: 'Zur Demo',
            actionButtonPostText: '',
          },
        },
      },
    },
    [NotificationEnum.ENROLLMENT_COMPLETED_POOLER]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Zusammenarbeitsanfrage angenommen',
          body: {
            introText:
              'Ein {{userRole}} hat Ihre Zusammenarbeitsanfrage angenommen und sich zum ersten mal angemeldet.',
          },
        },
      },
    },
    [NotificationEnum.ENROLLMENT_COMPLETED_DISPO]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Zusammenarbeitsanfrage angenommen',
          body: {
            introText:
              'Ein {{userRole}} hat Ihre Zusammenarbeitsanfrage angenommen und sich zum ersten mal angemeldet.',
          },
        },
      },
    },
    [NotificationEnum.ENROLL_PHONE]: {
      [RecipientEnum.USER]: {
        SMS: 'Um in Zukunft Anfragen per SMS erhalten zu können musst du deine Nummer mit folgendem Link bestätigen:\n{{actionLink}}',
      },
    },
    [NotificationEnum.AUTO_ENROLL_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Willkommen',
          body: {
            introText: 'Wir freuen uns, dich bei inpool zu begrüssen.',
            actionButtonText: 'Zum Login',
            actionButtonPreText:
              'Du kannst dich mit deinem bestehenden Windows bzw. Microsoft-Login unter folgender Adresse anmelden:',
            outroText:
              'Folgende Schritte sind dazu notwendig: <ol><li> Gebe deine E-Mail-Adresse ein. </li><li> Du wirst automatisch auf die Login-Seite deines Unternehmens weitergeleitet. Melde dich dort mit deinem bestehenden Login an. </li><li> Du wirst bei inpool automatisch angemeldet</li></ol>',
          },
        },
      },
    },
    [NotificationEnum.EXTERNAL_API_REQUEST_FAILED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - API Request Failed',
          body: {
            introText:
              'Es gab einen Fehler bei einem API Request, hier sind die Details zu dem Request:',
          },
        },
      },
    },
    [NotificationEnum.INVITEE_CANCELED]: {
      [RecipientEnum.USER]: {
        SMS: 'Ein Dienst wurde storniert: {{departmentName}}',
        EMAIL: {
          subject: 'IN-POOL - Stornierung: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde storniert:',
          },
        },
        PUSH: {
          title: 'IN-POOL - Stornierung: {{job.department.displayName}}',
          body: 'Dienst wurde storniert: {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender von {{customerName}} wurde auf dem Dienst storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
        PUSH: {
          title: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: 'Folgender Mitarbeitender von {{customerName}} wurde auf dem Dienst storniert: {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender von {{customerName}} wurde auf dem Dienst storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender wurde auf dem Dienst storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender wurde auf dem Dienst storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender wurde auf dem Dienst storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender wurde auf dem Dienst storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.ORGANISATION]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender von {{customerName}} wurde auf dem Dienst storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender von {{customerName}} wurde auf dem Dienst storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INVITEE_CANCELED]: {
      [RecipientEnum.USER]: {
        SMS: 'Ein Temporäreinsatz wurde storniert: {{departmentName}}',
        EMAIL: {
          subject:
            'IN-POOL - Stornierung: {{{employment.department.displayName}}}',
          body: {
            introText: 'Folgender Temporäreinsatz wurde storniert:',
          },
        },
        PUSH: {
          title: 'IN-POOL - Stornierung: {{employment.department.displayName}}',
          body: 'Temporäreinsatz wurde storniert: {{employment.department.displayName}} für {{formattedDate}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender von {{customerName}} wurde auf dem Einsatz storniert:',
          },
        },
        PUSH: {
          title: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: 'Eine Person von {{customerName}} wurde auf dem Einsatz storniert: {{employment.department.displayName}} für {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender von {{customerName}} wurde auf dem Einsatz storniert:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender wurde auf dem Einsatz storniert:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender wurde auf dem Einsatz storniert:',
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender wurde auf dem Einsatz storniert:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender von {{customerName}} wurde auf dem Einsatz storniert:',
          },
        },
      },
    },
    [NotificationEnum.INVITEE_REPLACED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Ersatz für {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender wurde auf diesem Dienst ersetzt:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Ersatz für {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Folgender Mitarbeitender wurde auf diesem Dienst ersetzt:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.INVITE]: {
      [RecipientEnum.USER]: {
        SMS: 'Dienstanfrage von {{customerName}}: {{departmentName}} \nZum Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Anfrage: {{{job.department.displayName}}}',
          body: {
            introText:
              'Du hast von {{customerName}} folgende Dienstanfrage erhalten:',
            actionButtonText: 'Zum Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Anfrage: {{job.department.displayName}}',
          body: 'Dienstanfrage von {{customerName}}: {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INVITE]: {
      [RecipientEnum.USER]: {
        SMS: 'Temporäreinsatz von {{customerName}}: {{departmentName}} \nZum Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Anfrage: {{{employment.department.displayName}}}',
          body: {
            introText:
              'Du hast von {{customerName}} folgende Temporäreinsatz Anfrage erhalten:',
            actionButtonText: 'Zum Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Anfrage: {{employment.department.displayName}}',
          body: 'Temporäreinsatz von {{customerName}}: {{employment.department.displayName}} für {{formattedDate}}',
        },
      },
    },
    [NotificationEnum.JOB_CANCELED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
        PUSH: {
          title: 'IN-POOL - Stornierung: {{{job.department.displayName}}}',
          body: 'Folgender Dienst wurde storniert: {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Stornierung: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde storniert:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.JOB_DECLINED]: {
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Dienstablehnung: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde abgelehnt:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.JOB_CLOSED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Dienst abgeschlossen: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde abgeschlossen:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Dienst abgeschlossen: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde abgeschlossen:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Dienst abgeschlossen: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde abgeschlossen:',
          },
        },
      },
    },
    [NotificationEnum.JOB_REOPENED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Dienst wieder offen: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde wieder geöffnet:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Dienst wieder offen: {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wurde wieder geöffnet:',
          },
        },
      },
    },
    [NotificationEnum.JOB_REOPENED_INVITE]: {
      [RecipientEnum.USER]: {
        SMS: 'Dienst wieder offen – Anfrage von {{customerName}}: {{departmentName}} \nZum Dashboard: {{actionLink}}',
        EMAIL: {
          subject:
            'IN-POOL - Anfrage wieder offen: {{{job.department.displayName}}}',
          body: {
            introText:
              'Folgender Dienst wurde wieder geöffnet. Du hast von {{customerName}} erneut folgende Dienstanfrage erhalten:',
            actionButtonText: 'Zum Dashboard',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Anfrage (wieder geöffnet): {{job.department.displayName}}',
          body: 'Dienst wieder geöffnet – Anfrage von {{customerName}}: {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
    },
    [NotificationEnum.JOB_REOPENED_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: '{{{customerName}}} - Dienst wieder offen',
          body: {
            introText:
              'Folgender Dienst wurde von {{customerName}} wieder geöffnet:',
            actionButtonText: 'Zum Dienst',
          },
        },
        PUSH: {
          title: '{{{customerName}}} - Dienst wieder offen',
          body: '{{customerName}} hat einen Dienst wieder geöffnet',
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Dienst wieder offen: {{#job}}{{#department}}{{{displayName}}}{{/department}} am {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/job}}',
          body: {
            introText:
              'Folgender Dienst wurde von {{customerName}} wieder geöffnet:',
            bookingButtonText: 'Zur Anfrage',
            submitButtonText: 'Zur Anfrage',
            bookingButtonMessage:
              'Um eine:n mögliche:n Mitarbeiter:in zu buchen oder die Anfrage abzulehnen, benutzen Sie folgenden Link:',
            submitButtonMessage:
              'Um eine:n mögliche:n Mitarbeiter:in einzureichen oder die Anfrage abzulehnen, benutzen Sie folgenden Link:',
          },
        },
      },
    },
    [NotificationEnum.JOB_MISSED]: {
      [RecipientEnum.OTHER_TRANSFER_EDITORS]: {
        EMAIL: {
          subject:
            'IN-POOL - Anderweitig besetzt {{{job.department.displayName}}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
          body: {
            introText: 'Folgender Dienst konnte anderweitig besetzt werden:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Anderweitig besetzt {{{job.department.displayName}}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
          body: {
            introText: 'Folgender Dienst konnte anderweitig besetzt werden:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Anderweitig besetzt {{{job.department.displayName}}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
          body: {
            introText: 'Folgender Dienst konnte anderweitig besetzt werden:',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_CANCELED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Stornierung: {{{employment.department.displayName}}}',
          body: {
            introText: 'Folgender Temporäreinsatz wurde storniert:',
            actionButtonText: 'Zum Einsatz',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Stornierung: {{{employment.department.displayName}}}',
          body: 'Folgender Temporäreinsatz wurde storniert: {{employment.department.displayName}} für {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Stornierung: {{{employment.department.displayName}}}',
          body: {
            introText: 'Folgender Temporäreinsatz wurde storniert:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Stornierung: {{{employment.department.displayName}}}',
          body: {
            introText: 'Folgender Temporäreinsatz wurde storniert:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Stornierung: {{{employment.department.displayName}}}',
          body: {
            introText: 'Folgender Temporäreinsatz wurde storniert:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Stornierung: {{{employment.department.displayName}}}',
          body: {
            introText: 'Folgender Temporäreinsatz wurde storniert:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_CLOSED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Einsatz abgeschlossen: {{{employment.department.displayName}}}',
          body: {
            introText: 'Folgender Temporäreinsatz wurde abgeschlossen:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Einsatz abgeschlossen: {{{employment.department.displayName}}}',
          body: {
            introText: 'Folgender Temporäreinsatz wurde abgeschlossen:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Einsatz abgeschlossen: {{{employment.department.displayName}}}',
          body: {
            introText: 'Folgender Temporäreinsatz wurde abgeschlossen:',
          },
        },
      },
      [RecipientEnum.OTHER_TRANSFER_EDITORS]: {
        EMAIL: {
          subject:
            'IN-POOL - Anderweitig besetzt {{{employment.department.displayName}}} für {{formattedDate}}',
          body: {
            introText:
              'Folgender Temporäreinsatz konnte anderweitig besetzt werden:',
          },
        },
      },
    },
    [NotificationEnum.NEW_ACCOUNT_PHONE_TOKEN]: {
      [RecipientEnum.USER]: {
        SMS: 'IN-POOL - Dein Bestätigungscode:\n{{secret}}',
      },
    },
    [NotificationEnum.EMAIL_OPT_IN]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - E-Mail geändert',
          body: {
            actionButtonPreText: `Du hast deine E-Mail-Adresse geändert. <br />Bitte bestätige die Änderung mit folgendem Link:`,
            actionButtonText: 'Bestätigen',
          },
        },
      },
    },
    [NotificationEnum.PHONE_OPT_IN]: {
      [RecipientEnum.USER]: {
        SMS: 'Du hast deine Nummer geändert. Bitte bestätige die Änderung mit folgendem Link:\n{{actionLink}}',
      },
    },
    [NotificationEnum.ORGANISATION_REQUEST]: {
      [RecipientEnum.USER]: {
        SMS:
          'Neuer Einsatzort von {{customerName}}.\n' +
          'Bitte annehmen oder ablehnen: {{actionLink}}',
        EMAIL: {
          subject: 'Angebot für einen neuen Einsatzort',
          body: {
            actionButtonPreText: `{{customerName}} bietet dir Einsätze an einem neuen Einsatzort an. <br />Du kannst unser Angebot auf deinem Dashboard annehmen oder ablehnen.`,
            actionButtonText: 'Zum Dashboard',
          },
        },
        PUSH: {
          title: 'Angebot für einen neuen Einsatzort',
          body: 'Neuer Einsatzort von {{customerName}}. Bitte annehmen oder ablehnen.',
        },
      },
    },

    [NotificationEnum.POOL_ACCEPTED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Zusammenarbeitsanfrage angenommen',
          body: {
            introText:
              'Ein {{userRole}} hat Ihre Zusammenarbeitsanfrage angenommen.',
            actionButtonText: 'Zum Mitarbeitenden',
          },
        },
      },
    },
    [NotificationEnum.POOL_DECLINED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Zusammenarbeitsanfrage abgelehnt',
          body: {
            introText:
              'Ein {{userRole}} hat Ihre Zusammenarbeitsanfrage abgelehnt.',
          },
        },
      },
    },
    [NotificationEnum.POOLER_INVITE_REMINDER]: {
      [RecipientEnum.USER]: {
        SMS: 'Erinnerung: Einladung bei {{departmentName}} ist noch offen',
        EMAIL: {
          subject:
            'Erinnerung - Einladung bei {{{job.department.displayName}}}',
          body: {
            introText: 'Für folgenden Dienst ist deine Antwort ausstehend:',
            actionButtonText: 'Zum Dashboard',
          },
        },
        PUSH: {
          title: 'Erinnerung - Einladung bei {{job.department.displayName}}',
          body: 'Einladung bei {{job.department.displayName}} vom {{job.date}} ist noch offen',
        },
      },
    },
    [NotificationEnum.POOLER_JOB_REMINDER]: {
      [RecipientEnum.USER]: {
        SMS: 'Erinnerung: Einsatz bei {{departmentName}} vom {{jobDate}} beginnt um {{jobStartTime}} Uhr',
        EMAIL: {
          subject: 'Erinnerung - Einsatz bei {{{job.department.displayName}}}',
          body: {
            introText: 'Folgender Dienst wird in Kürze beginnen:',
          },
        },
        PUSH: {
          title: 'Erinnerung - Einsatz bei {{job.department.displayName}}',
          body: 'Einsatz bei {{job.department.displayName}} vom {{job.date}} beginnt um {{jobStartTime}} Uhr',
        },
      },
    },
    [NotificationEnum.POOLER_TRANSFERRED]: {
      [RecipientEnum.USER]: {
        SMS: 'Du wurdest für den Dienst umgebucht: zu {{departmentName}} \nZum Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Umgebucht: zu {{{job.department.displayName}}}',
          body: {
            introText: 'Du wurdest für den folgenden Dienst umgebucht:',
            from: 'Von',
            to: 'Zu',
          },
        },
        PUSH: {
          title: 'IN-POOL - Umgebucht: zu {{job.department.displayName}}',
          body: 'Du wurdest für den Dienst am {{job.date}} umgebucht: zu {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
    },
    [NotificationEnum.POOL_REMOVED]: {
      [RecipientEnum.USER]: {
        SMS: 'Hiermit bestätigen wir, dass du  aus unserem Pool gelöscht wurdest und deine Daten diesbezüglichen entfernt wurden.',
        EMAIL: {
          subject: 'IN-POOL - Abmeldung: {{{customerName}}}-Pool',
          body: {
            introText:
              'Hiermit bestätigen wir, dass du aus unserem Pool abgemeldet bist und deine diesbezüglichen Angaben gelöscht werden.',
            outroText: 'Bei Fragen stehen wir dir gerne zur Verfügung.',
          },
        },
        PUSH: {
          title: 'IN-POOL - Abmeldung: {{customerName}}-Pool',
          body: 'Hiermit bestätigen wir, dass du aus unserem Pool abgemeldet bist und deine diesbezüglichen Angaben gelöscht werden.',
        },
      },
    },
    [NotificationEnum.POOL_REQUEST]: {
      [RecipientEnum.USER]: {
        SMS:
          '{{customerName}} möchte dich zum Pool hinzufügen.\n' +
          'Anfrage annehmen oder ablehnen: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Poolanfrage',
          body: {
            introText: `{{customerName}} möchte dich zum Pool hinzufügen.<br />Du kannst diese Anfrage auf deinem Dashboard annehmen oder ablehnen.`,
            actionButtonText: 'Zum Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Poolanfrage',
          body: '{{customerName}} möchte dich zum Pool hinzufügen. Anfrage annehmen oder ablehnen.',
        },
        SYS: '',
      },
    },
    [NotificationEnum.POSSIBLE_CANDIDATE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Neue mögliche mitarbeitende Person',
          body: {
            introText:
              'Für folgenden Dienst wurde eine mögliche mitarbeitende Person eingereicht:',
            textBeforeAction: 'Akzeptiere den gewünschten Mitarbeitenden:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Neue mögliche mitarbeitende Person',
          body: {
            introText:
              'Für folgenden Dienst wurde eine mögliche mitarbeitende Person eingereicht:',
            textBeforeAction: 'Akzeptiere den gewünschten Mitarbeitenden:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.PROFILE_INFO_CHANGED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Poolerdaten angepasst',
          body: {
            introText:
              'Bei {{userName}} wurden die folgenden Daten aktualisiert:',
            changedByEditor:
              'Die Daten wurden von {{editorName}} aktualisiert.',
            changedByDifferentCustomer:
              'Die Daten wurden von einem anderen Kunden aktualisiert.',
          },
          changedInfoKeys: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            email: 'E-Mail',
            sex: 'Geschlecht',
            phone: 'Telefon',
            notifyEmail: 'E-Mail Benachrichtigung',
            notifySms: 'SMS Benachrichtigung',
            shifts: 'Schichten',
            jobTypes: 'Dienstarten',
          },
        },
      },
    },
    [NotificationEnum.REASK]: {
      [RecipientEnum.USER]: {
        SMS: 'Antwort ist ausstehend this is a long text to test the shortening abc lorem ipsum abc test test: {{departmentName}}  \nZum Dashboard: {{actionLink}}',
        EMAIL: {
          subject:
            'IN-POOL - Antwort ausstehend: {{{job.department.displayName}}}',
          body: {
            introText: 'Für folgenden Dienst ist deine Antwort ausstehend:',
            actionButtonText: 'Zum Dashboard',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Antwort ist ausstehend: {{job.department.displayName}}',
          body: 'Dienstanfrage von {{customerName}}: {{job.department.displayName}} am {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
        SYS: '',
      },
    },
    [NotificationEnum.TRANSFER_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfer abgelehnt: {{{job.department.displayName}}}',
          body: {
            introText:
              'Bei folgendem Dienst wurde der Transfer von {{customerName}} abgelehnt:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfer abgelehnt: {{{job.department.displayName}}}',
          body: {
            introText:
              'Bei folgendem Dienst wurde der Transfer von {{customerName}} abgelehnt:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_TRANSFER_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfer abgelehnt: {{{employment.department.displayName}}}',
          body: {
            introText:
              'Bei folgendem Einsatz wurde der Transfer von {{customerName}} abgelehnt:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfer abgelehnt: {{{employment.department.displayName}}}',
          body: {
            introText:
              'Bei folgendem Einsatz wurde der Transfer von {{customerName}} abgelehnt:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_POSSIBLE_CANDIDATE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Neue mögliche mitarbeitende Person',
          body: {
            introText:
              'Für folgenden Einsatz wurde eine mögliche mitarbeitende Person eingereicht:',
            textBeforeAction: 'Akzeptiere den gewünschten Mitarbeitenden:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Neue mögliche mitarbeitende Person',
          body: {
            introText:
              'Für folgenden Einsatz wurde eine mögliche mitarbeitende Person eingereicht:',
            textBeforeAction: 'Akzeptiere den gewünschten Mitarbeitenden:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
    },
    [NotificationEnum.TRANSFER_EXTERNAL_API_REQUEST_FAILED]: {
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Dienstübermittlung: {{#job}}{{#department}}{{{displayName}}}{{/department}} am {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/job}}',
          body: {
            introText: `Beim Übertragen eines Dienstes per API ist etwas schiefgegangen. <br />Gerne übergibt {{customerName}} Ihnen folgenden Dienst per E-Mail:`,
            bookingButtonText: 'Buchen',
            submitButtonText: 'Einreichen',
            bookingButtonMessage:
              'Um eine:n Mitarbeiter:in direkt zu buchen, benutzen Sie folgenden Link:',
            submitButtonMessage:
              'Um eine:n mögliche(n) Mitarbeiter:in(en) einzureichen, benutzen Sie folgenden Link:',
          },
        },
      },
    },
    [NotificationEnum.TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: '{{{customerName}}} - Übermittlung eines Dienstes',
          body: {
            introText:
              'Gerne übergibt {{customerName}} Ihnen folgenden Dienst per E-Mail:',
            actionButtonText: 'Zum Dienst',
          },
        },
        PUSH: {
          title: '{{{customerName}}} - Übermittlung eines Dienstes',
          body: 'Gerne übergibt {{customerName}} Ihnen folgenden Dienst',
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Dienstübermittlung: {{#job}}{{#department}}{{{displayName}}}{{/department}} am {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/job}}',
          body: {
            introText:
              'Gerne übergibt {{customerName}} Ihnen folgenden Dienst per E-Mail:',
            bookingButtonText: 'Zur Anfrage',
            submitButtonText: 'Zur Anfrage',
            bookingButtonMessage:
              'Um eine:n mögliche:n Mitarbeiter:in zu buchen oder die Anfrage abzulehnen, benutzen Sie folgenden Link:',
            submitButtonMessage:
              'Um eine:n mögliche:n Mitarbeiter:in einzureichen oder die Anfrage abzulehnen, benutzen Sie folgenden Link:',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: '{{{customerName}}} - Übermittlung eines Einsatzes',
          body: {
            introText:
              'Gerne übergibt {{customerName}} Ihnen folgenden Einsatz:',
            actionButtonText: 'Zum Einsatz',
          },
        },
        PUSH: {
          title: '{{{customerName}}} - Übermittlung eines Einsatzes',
          body: 'Gerne übergibt {{customerName}} Ihnen folgenden Einsatz',
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Einsatzübermittlung: {{#employment}}{{#department}}{{{displayName}}}{{/department}} am {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/employment}}',
          body: {
            introText:
              'Gerne übergibt {{customerName}} Ihnen folgenden Einsatz per E-Mail:',
            submitButtonText: 'Zur Anfrage',
            submitButtonMessage:
              'Um eine:n mögliche:n Mitarbeiter:in einzureichen oder die Anfrage abzulehnen, benutzen Sie folgenden Link:',
          },
        },
      },
    },
    [NotificationEnum.AVAILABILITY_UPDATES_REPORT]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'Verfügbarkeiten aktualisierungen',
          body: {
            introText:
              'Im Anhang finden Sie die Verfügbarkeiten der Mitarbeiter:innen welche sich seit der letzten Mail geändert haben.',
          },
        },
      },
    },
    [NotificationEnum.TWO_FACTOR_AUTH_PHONE]: {
      [RecipientEnum.USER]: {
        SMS: 'Ihr Code lautet: {{secret}}',
      },
    },
    [NotificationEnum.TWO_FACTOR_AUTH_EMAIL]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Zwei-Faktor-Authentifizierung',
          body: {
            introText:
              'Ihr Code für die Zwei-Faktor-Authentifizierung lautet: {{secret}}',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INFORMATION_CHANGED]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Einsatzinformationen geändert',
          body: {
            introText:
              'Ein Temporär-Einsatz hat die folgenden Daten aktualisiert:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Einsatzinformationen geändert',
          body: {
            introText:
              'Ein Temporär-Einsatz hat die folgenden Daten aktualisiert:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Einsatzinformationen geändert',
          body: {
            introText:
              'Ein Temporär-Einsatz hat die folgenden Daten aktualisiert:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Einsatzinformationen geändert',
          body: {
            introText:
              'Ein Temporär-Einsatz hat die folgenden Daten aktualisiert:',
            actionButtonText: 'Zum Einsatz',
          },
        },
      },
    },
    [NotificationEnum.AUTO_BOOKED_ON_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Gebucht {{user.firstName}} {{user.lastName}} am {{job.date}} auf {{job.department.displayName}}',
          body: {
            introText:
              'Eine Person wurde für folgenden Dienst automatisch beim Transfer gebucht:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.AUTO_POSSIBLE_CANDIDATE_ON_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Möglicher Kandidat {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'Eine Person wurde für folgenden Dienst automatisch beim Transfer als möglicher Kandidat eingereicht:',
            actionButtonText: 'Zum Dienst',
          },
        },
      },
    },
    [NotificationEnum.JOB_REQUESTED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Dienstanfrage',
          body: {
            introText:
              'Es wurde eine neue Dienstanfrage erstellt, bitte prüfe die Anfrage und akzeptiere oder lehne sie ab.',
            actionButtonText: 'Zu den Anfragen',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Dienstanfrage',
          body: {
            introText:
              'Es wurde eine neue Dienstanfrage erstellt, bitte prüfe die Anfrage und akzeptiere oder lehne sie ab.',
            actionButtonText: 'Zu den Anfragen',
          },
        },
      },
    },
    [NotificationEnum.JOB_RETRACTION_REQUESTED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Anfrage zum Zurückziehen des Dienstes',
          body: {
            introText:
              'Es wurde eine Anfrage zum Zurückziehen des Dienstes erstellt, bitte prüfe die Anfrage und akzeptiere oder lehne sie ab.',
            actionButtonText: 'Zu den Anfragen',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Anfrage zum Zurückziehen des Dienstes',
          body: {
            introText:
              'Es wurde eine Anfrage zum Zurückziehen des Dienstes erstellt, bitte prüfe die Anfrage und akzeptiere oder lehne sie ab.',
            actionButtonText: 'Zu den Anfragen',
          },
        },
      },
    },
    [NotificationEnum.JOB_REQUEST_ACCEPTED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Dienstanfrage akzeptiert',
          body: {
            introText:
              'Die folgende Dienstanfrage wurde von {{activeUserFirstName}} {{activeUserLastName}} akzeptiert:',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Dienstanfrage akzeptiert',
          body: {
            introText:
              'Die folgende Dienstanfrage wurde von {{activeUserFirstName}} {{activeUserLastName}} akzeptiert:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Dienstanfrage akzeptiert',
          body: {
            introText:
              'Die folgende Dienstanfrage wurde von {{activeUserFirstName}} {{activeUserLastName}} akzeptiert:',
          },
        },
      },
    },
    [NotificationEnum.JOB_REQUEST_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Dienstanfrage abgelehnt',
          body: {
            introText:
              'Die folgende Dienstanfrage wurde von {{activeUserFirstName}} {{activeUserLastName}} abgelehnt:',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Dienstanfrage abgelehnt',
          body: {
            introText:
              'Die folgende Dienstanfrage wurde von {{activeUserFirstName}} {{activeUserLastName}} abgelehnt:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Dienstanfrage abgelehnt',
          body: {
            introText:
              'Die folgende Dienstanfrage wurde von {{activeUserFirstName}} {{activeUserLastName}} abgelehnt:',
          },
        },
      },
    },
    [NotificationEnum.JOB_RETRACTION_REQUEST_ACCEPTED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Anfrage zum Zurückziehen des Dienstes akzeptiert',
          body: {
            introText:
              'Die Anfrage zum Zurückziehen des Dienstes wurde von {{activeUserFirstName}} {{activeUserLastName}} akzeptiert:',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Anfrage zum Zurückziehen des Dienstes akzeptiert',
          body: {
            introText:
              'Die Anfrage zum Zurückziehen des Dienstes wurde von {{activeUserFirstName}} {{activeUserLastName}} akzeptiert:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Anfrage zum Zurückziehen des Dienstes akzeptiert',
          body: {
            introText:
              'Die Anfrage zum Zurückziehen des Dienstes wurde von {{activeUserFirstName}} {{activeUserLastName}} akzeptiert:',
          },
        },
      },
    },
    [NotificationEnum.JOB_RETRACTION_REQUEST_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Anfrage zum Zurückziehen des Dienstes abgelehnt',
          body: {
            introText:
              'Die Anfrage zum Zurückziehen des Dienstes wurde von {{activeUserFirstName}} {{activeUserLastName}} abgelehnt:',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Anfrage zum Zurückziehen des Dienstes abgelehnt',
          body: {
            introText:
              'Die Anfrage zum Zurückziehen des Dienstes wurde von {{activeUserFirstName}} {{activeUserLastName}} abgelehnt:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Anfrage zum Zurückziehen des Dienstes abgelehnt',
          body: {
            introText:
              'Die Anfrage zum Zurückziehen des Dienstes wurde von {{activeUserFirstName}} {{activeUserLastName}} abgelehnt:',
          },
        },
      },
    },
    [NotificationEnum.NEW_JOB_REQUEST_NEEDS_APPROVAL]: {
      [RecipientEnum.CUSTOMER]: {
        SMS: 'Es wurde eine neue Dienstanfrage eingereicht. Bitte prüfe die Anfrage:\n{{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Neue Dienstanfrage',
          body: {
            introText:
              'Eine neue Dienstanfrage wurde für folgenden Dienst eingereicht:',
            textBeforeAction:
              'Prüfe die Anfrage und akzeptiere oder lehne sie ab:',
            actionButtonText: 'Zu den offenen Anfragen',
          },
        },
      },
    },
    [NotificationEnum.UNMAPPED_PERIGON_JOBS]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Dienste mit fehlender Perigon-Zuordnung',
          body: {
            introText:
              'Es gibt {{unmappedJobsCount}} Dienste mit fehlender Perigon-Zuordnung.',
            unmappedPerigonJobsMessage:
              'Bitte überprüfe die Perigon-Zuordnungen der Dienste und korrigiere sie.',
            actionButtonText: 'Zum den Diensten',
          },
        },
      },
    },
    [NotificationEnum.DISPO_REMOVED_FROM_POOL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Disponent entfernt',
          body: {
            introText: 'Ein Disponent wurde aus dem Pool entfernt.',
          },
        },
      },
    },
    [NotificationEnum.POOLER_REMOVED_FROM_POOL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Pooler entfernt',
          body: {
            introText: 'Ein Pooler wurde aus dem Pool entfernt.',
          },
        },
      },
    },
    [NotificationEnum.REQUESTER_REMOVED_FROM_POOL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Besteller entfernt',
          body: {
            introText: 'Ein Besteller wurde aus dem Pool entfernt.',
          },
        },
      },
    },
  },
};
